export enum InterfaceConfigPaths {
  INTERFACE_CONFIG = '/interface-config',
  WIDGET_CONFIG = '/widget-config'
}
